import {
  ArrowDownwardOutlined,
  ArrowUpwardOutlined,
  CloseOutlined,
  DeleteOutline,
} from "@material-ui/icons";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Autocomplete,
  Button,
  CardHeader,
  Chip,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../helpers/ExtraHelpers";
import useConfirm from "../hooks/useConfirm";
import useToast from "../hooks/useToast";
import Formservice from "../service/Formservice";
import logo from "./logo.png";
import Identifiant from "./reusable/Identifiant";
import NB from "./reusable/NB";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

const PretentionEtChoixLocalisation = () => {
  const ref = localStorage.getItem("ref");
  const parts = ref.split("_");
  const prefix = parts[0];
  const [identif, setIdentif] = useState({});
  const navigate = useNavigate();
  const [lotChoisis, setLotChoisis] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedLot, setSelectedLot] = useState(null);
  const [formNewLotShow, setFormNewLotShow] = useState(false);
  const [formErrors, setFormErrors] = useState({
    pretentionError: null,
    districtError: null,
  });
  const LOT_MIN_AU_CHOIX = 1;

  const [listLot, setListLot] = useState([]);
  const [listLotLoading, setListLotLoading] = useState(false);
  const [listLotInitial, setListLotInitial] = useState([]);
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleFetchIdentite = () => {
    setLoading(true);
    Formservice.details(ref)
      .then((result) => {
        if (result && result.data) {
          // console.log("result", result.data.id_type);
          setIdentif(result.data);
          handleFetchLotList(result.data.id_type);
          setLotChoisis(result.localisation);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const toggleShowFormNewDistrict = () => {
    setFormNewLotShow(!formNewLotShow || false);
  };

  const handleSetSelectedDistrict = (dist) => {
    setSelectedLot(
      listLot.find((item) => item.localisation === dist.target.textContent),
    );
  };

  const handleAddDistrict = () => {
    if (selectedLot) {
      const new_district = {
        localisation: selectedLot.localisation,
        id_identite: identif.id_identite,
        numero: lotChoisis.length + 1,
      };
      let copy_districts = lotChoisis.slice();
      copy_districts.push(new_district);

      setLotChoisis(copy_districts);
      setSelectedLot(null);
      setFormNewLotShow(false);
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez selectionner le Lot/Localisation à choisir",
      );
    }
  };

  const handleCheckError = () => {
    setFormErrors({
      pretentionError: !identif.pretention_salariale
        ? "Prétention salariale requise"
        : null,
      districtError:
        lotChoisis.length < LOT_MIN_AU_CHOIX
          ? `Vous devez ajouter au moins ${LOT_MIN_AU_CHOIX} Lots/localisations de votre choix.<br/><br/>
          Pour en ajouter un :<br/> <ul><li>Veuillez cliquer sur le bouton 
          <b style="color:red" >Ajouter lot</b></li><li>Choisir le Lot de votre choix</li><li>Cliquer sur <b style="color:red" >ok</b></li></ul>
           (Vous pouvez répéter l'opération plusieurs fois et reordonner les lots selon votre choix si plusieurs choix sont disponibles).`
          : null,
    });
    return Object.values(formErrors).every((item) => item === null);
  };
  const handlePrevious = () => {
    navigate("/autrecompetence");
  };

  const handleEditPretentionSalariale = (pretention) => {
    Formservice.editPretentionSalariale(identif).then((res) => {
      if (res && res.data) {
        if (!res.success) {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      }
    });
  };

  const handleSaveLocalisation = (direction = "fichier") => {
    try {
      Formservice.saveChoixLocalisation(lotChoisis)
        .then((res) => {
          if (res && res.success) {
            showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
            //handleFetchIdentite();
            // setTimeout(function () {navigate(`/${direction}`); }, 2000);
            navigate(`/${direction}`);
          } else {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .catch((e) => {
          showToast(TYPE_NOTIFICATION.ERROR, e.toString());
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      showToast(TYPE_NOTIFICATION.ERROR, e.toString());
    }
  };

  const handleSaveAll = (direction = "fichier") => {
    setLoading(true);
    if (handleCheckError()) {
      handleSaveLocalisation(direction);
      handleEditPretentionSalariale();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleDeleteAndReorderDistricts = (lot) => {
    setLotChoisis(
      lotChoisis
        .filter((item) => item.localisation !== lot.localisation)
        .map((item, idx) => {
          return { ...item, numero: idx + 1 };
        }),
    );
  };

  const handleMoveUp = (district) => {
    if (district.numero > 0) {
      let idx = lotChoisis.findIndex(
        (item) => item.localisation === district.localisation,
      );
      let copy_dist = lotChoisis.slice();

      let currentIndex = copy_dist[idx].numero;
      copy_dist[idx].numero = copy_dist[idx - 1].numero;
      copy_dist[idx - 1].numero = currentIndex;
      setLotChoisis(copy_dist.sort((a, b) => a.numero - b.numero));
    }
  };

  const handleMoveDown = (district) => {
    if (district.numero < lotChoisis.length) {
      let idx = lotChoisis.findIndex(
        (item) => item.localisation === district.localisation,
      );
      let copy_dist = lotChoisis.slice();
      let currentIndex = copy_dist[idx].numero;
      copy_dist[idx].numero = copy_dist[idx + 1].numero;
      copy_dist[idx + 1].numero = currentIndex;
      setLotChoisis(copy_dist.sort((a, b) => a.numero - b.numero));
    }
  };

  const handleRemoveDistrict = (distric) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer ce Lot/Localisaiton?",
      () => {
        handleDeleteAndReorderDistricts(distric);
      },
    );
  };

  const handleFetchLotList = (id_type) => {
    setListLotLoading(true);
    Formservice.get_lot_list(id_type)
      .then((res) => {
        if (res && res.success) {
          setListLot(res.data);
          setListLotInitial(res.data);
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .catch((e) => {
        showToast(TYPE_NOTIFICATION.ERROR, e.toString());
      })
      .finally(() => {
        setListLotLoading(false);
      });
  };

  const handleFilterLots = () => {
    setListLot(
      listLotInitial
        .filter(
          (item) =>
            !lotChoisis.some((it) => it.localisation === item.localisation),
        )
        .sort((a, b) => a.localisation - b.localisation),
    );
  };

  useEffect(() => {
    handleFetchIdentite();
  }, []);

  useEffect(() => {
    handleCheckError();
    handleFilterLots();
  }, [lotChoisis, identif, listLotInitial]);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid
        container
        display={"flex"}
        height={"100vh"}
        alignItems={"center"}
        justifyContent="center"
      >
        <Grid
          item
          xs={12}
          md={10}
          lg={7}
          minHeight={"90vh"}
          borderRadius={"20px"}
          // border={"3px #0747a1 solid "}
          border={"2px rgba(11, 93, 208,0.5) solid "}
          boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
          display={"flex"}
          flexDirection={"column"}
          p={2.5}
        >
          <Grid item>
            <Grid container item xs={12} justifyContent={"center"}>
              <img
                src={logo}
                className="App-logo"
                alt="logo"
                style={{
                  maxWidth: "75px",
                  maxHeight: "75px",
                  // marginLeft: "40%",
                  // display: window.innerWidth <= 600 ? "block" : "none",
                }}
              />
            </Grid>
            <h1 style={{ marginBottom: "10px", textAlign: "center" }}>
              Prétention salariale et choix de localisation
            </h1>
          </Grid>
          <Grid item flexGrow={1} display={"flex"} flexDirection={"column"}>
            <Grid container>
              <Grid item xs={12} md={6} style={{ marginBottom: "10px" }}>
                <Identifiant identif={identif} prefix={prefix} refer={ref} />
              </Grid>
              <Grid item xs={12} md={6}>
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires",
                    "Le bouton Ajouter Lot permet d'ajouter Lot/localisation souhaitée.",
                    "Veuillez cliquer sur suivant pour passer au suivant.",
                  ]}
                />
              </Grid>
            </Grid>
            <Grid
              container
              display={"flex"}
              flexDirection={"column"}
              flexGrow={1}
            >
              <Grid item flexGrow={0.5}>
                <CardHeader title={"Prétention salariale *"} />
                <FormControl sx={{ ml: 2 }}>
                  <FormLabel>
                    Votre minimum de prétention salariale accepté *
                  </FormLabel>
                  <TextField
                    size="small"
                    // type="number"
                    value={formatNumber(identif.pretention_salariale)}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      setIdentif({
                        ...identif,
                        pretention_salariale: val,
                      });
                    }}
                    inputProps={{
                      style: { textAlign: "end", fontSize: "20px" },
                    }}
                    error={formErrors.pretentionError}
                    helperText={formErrors.pretentionError}
                    InputProps={{
                      inputMode: "numeric",
                      endAdornment: (
                        <InputAdornment sx={{ ml: 2 }}>{` MGA`}</InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Divider variant="middle" sx={{ mt: 2 }} />
              <Grid item flexGrow={1}>
                <CardHeader title={"Choix de Lots/localisation *"} />
                <Grid item display={"flex"} justifyContent={"start"}>
                  <FormControl sx={{ m: 2 }} fullWidth>
                    <FormLabel>
                      Veuillez ajouter les Lots/localistaions de votre choix par
                      ordre de préference ({`${LOT_MIN_AU_CHOIX} minimum`})
                    </FormLabel>
                    <Grid item sx={{ margin: { md: 5 } }}>
                      {lotChoisis
                        ? lotChoisis.map((item, idx) => (
                            <Paper key={idx} sx={{ pl: 1, pr: 1, mb: 1 }}>
                              <Grid
                                container
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                                flexDirection={"row"}
                              >
                                <Grid item xs={2}>
                                  <IconButton
                                    color="primary"
                                    title={`Deplacer le vers le haut`}
                                    disabled={item.numero - 1 === 0}
                                    onClick={(e) => handleMoveUp(item)}
                                  >
                                    <ArrowUpwardOutlined />
                                  </IconButton>
                                  <IconButton
                                    color="primary"
                                    title={`Deplacer le vers le bas`}
                                    disabled={item.numero === lotChoisis.length}
                                    onClick={(e) => handleMoveDown(item)}
                                  >
                                    <ArrowDownwardOutlined />
                                  </IconButton>
                                </Grid>
                                <Grid
                                  item
                                  xs={9}
                                  display={"flex"}
                                  alignItems={"center"}
                                  textOverflow={"ellipsis"}
                                >
                                  <Chip
                                    sx={{ mr: 2 }}
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    label={`Choix N°${item.numero}`}
                                  />
                                  <Typography
                                    sx={{
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      WebkitLineClamp: {
                                        xs: 4, // mobile
                                        sm: 4, // tablette
                                        md: 4, // desktop
                                      },
                                      //maxWidth: "60vw",
                                    }}
                                    title={`${item.localisation}`}
                                  >{`${item.localisation}`}</Typography>
                                </Grid>
                                <Grid item p={0.5} xs={1}>
                                  <IconButton
                                    color="error"
                                    title={`Supprimer ${item.localisation}`}
                                    onClick={(e) => handleRemoveDistrict(item)}
                                  >
                                    <DeleteOutline />
                                  </IconButton>
                                  {/* <LoadingButton>ok</LoadingButton> */}
                                  {/* <TextField
                            size="small"
                            type="number"
                            sx={{ width: 60 }}
                            label="Ordre"
                          />
                          <LoadingButton sx={{ml:0.5}} variant="outlined">OK</LoadingButton> */}
                                </Grid>
                              </Grid>
                            </Paper>
                          ))
                        : ""}
                    </Grid>
                    <Grid >
                      <FormHelperText sx={{ color: "error.main" , width: "100%"}}>
                        <Alert
                          severity="error"
                          variant="outlined"
                          sx={{
                            mr: 3,
                            display: !!formErrors.districtError ? "" : "none",
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: formErrors.districtError,
                            }}
                          ></div>
                        </Alert>
                      </FormHelperText>
                    </Grid>
                    <Grid
                      item
                      display={"flex"}
                      m={1}
                      sx={{ mr: { md: 5 }, ml: { md: 3, xs: -1 } }}
                      justifyContent={formNewLotShow ? "space-around" : "end"}
                      flexDirection={"row"}
                      alignItems={"center"}
                    >
                      <Grid>
                        <Button
                          onClick={toggleShowFormNewDistrict}
                          variant={formNewLotShow ? "text" : "contained"}
                        >
                          {formNewLotShow ? <CloseOutlined /> : "Ajouter Lot"}
                        </Button>
                      </Grid>
                      <Grid
                        container
                        style={{
                          display: formNewLotShow ? "flex" : "none",
                        }}
                        justifyContent={
                          formNewLotShow ? "space-around" : "start"
                        }
                        flexDirection={"row"}
                        ml={0.5}
                      >
                        <Autocomplete
                          loading={listLotLoading}
                          loadingText="Chargement des localisations ..."
                          size="small"
                          options={listLot}
                          onChange={handleSetSelectedDistrict}
                          value={selectedLot}
                          getOptionLabel={(option) => option.localisation}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Localisation"
                              placeholder="Choix de Localisation"
                            />
                          )}
                          sx={{ flexGrow: 1, mr: 0.5 }}
                        />
                        <LoadingButton
                          onClick={(e) => handleAddDistrict()}
                          variant="contained"
                        >
                          OK
                        </LoadingButton>
                      </Grid>
                    </Grid>
                    <Grid>
                      {/* <Autocomplete 
                    //  options={}
                    /> */}
                    </Grid>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider variant="middle" sx={{ mt: 2, mb: 2 }} />
          <Grid item m={3} display={"flex"} justifyContent={"space-between"}>
            <Button variant="outlined" onClick={handlePrevious}>
              Retour
            </Button>
            <LoadingButton
              loading={loading}
              variant="outlined"
              sx={{ marginLeft: "auto" }}
              onClick={() => handleSaveAll("fichier")}
              disabled={
                !Object.values(formErrors).every((item) => item === null)
              }
              color="primary"
            >
              Suivant
            </LoadingButton>
          </Grid>
          <Grid item mb={3}>
            <footer
              style={{
                color: "#0747a1",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR
              LE DEVELOPPEMENT
            </footer>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PretentionEtChoixLocalisation;
